module.exports = __webpack_public_path__ + "img/achievement_10.60943d09.png";